import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RouteDebug = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="header">
        <h1>Route Debug</h1>
        <p>Debug routing issues</p>
      </div>
      
      <div className="card">
        <h3>Current Route Info</h3>
        <div style={{ fontFamily: 'monospace', fontSize: '14px' }}>
          <div><strong>Pathname:</strong> {location.pathname}</div>
          <div><strong>Search:</strong> {location.search}</div>
          <div><strong>Hash:</strong> {location.hash}</div>
          <div><strong>Full URL:</strong> {window.location.href}</div>
        </div>
      </div>

      <div className="card">
        <h3>Test Navigation</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button 
            onClick={() => navigate('/')} 
            className="btn btn-primary"
          >
            Go to Home (/)
          </button>
          
          <button 
            onClick={() => navigate('/dr-grant/login')} 
            className="btn btn-primary"
          >
            Go to Dr. Grant Login
          </button>
          
          <button 
            onClick={() => navigate('/student/login')} 
            className="btn btn-primary"
          >
            Go to Student Login
          </button>
          
          <button 
            onClick={() => navigate('/test')} 
            className="btn btn-primary"
          >
            Go to Test Page
          </button>
        </div>
      </div>

      <div className="card">
        <h3>Direct Links</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <a href="/" className="btn btn-secondary">
            Direct Link: Home
          </a>
          <a href="/dr-grant/login" className="btn btn-secondary">
            Direct Link: Dr. Grant Login
          </a>
          <a href="/student/login" className="btn btn-secondary">
            Direct Link: Student Login
          </a>
          <a href="/test" className="btn btn-secondary">
            Direct Link: Test
          </a>
        </div>
      </div>
    </div>
  );
};

export default RouteDebug;